var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('listEvents')],1),_c('v-col',{attrs:{"cols":"12","md":"9"}},[_c('dataTableTestVue'),(_vm.$route.params.idTest)?_c('dataTableSerieVue'):_vm._e(),_c('modalSelectTestVue'),_c('modalFormNewEventsVue')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }